import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./lib/i18n";
import { CurrencyProvider } from "./lib/currency";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import MarketplacePage from "./pages/MarketplacePage";
import ListingDetailPage from "./pages/ListingDetailPage";
import AIToolsPage from "./pages/AIToolsPage";
import DashboardPage from "./pages/DashboardPage";
import BlogPage from "./pages/BlogPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import ValuationPage from "./pages/ValuationPage";
import IdeaEvaluatorPage from "./pages/IdeaEvaluatorPage";
import MatchesPage from "./pages/MatchesPage";
import WhatsAppPage from "./pages/WhatsAppPage";
import FounderPage from "./pages/FounderPage";
import PublicUserPage from "./pages/PublicUserPage";
import AdminPage from "./pages/AdminPage";
import "./App.css";

function Protected({ children }) {
  const { user, token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (token && !user) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading...</div>;
  return children;
}

function App() {
  return (
    <I18nProvider>
      <CurrencyProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" theme="light" richColors />
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/marketplace" element={<MarketplacePage />} />
                <Route path="/listing/:id" element={<ListingDetailPage />} />
                <Route path="/ai-tools" element={<AIToolsPage />} />
                <Route path="/valuation" element={<ValuationPage />} />
                <Route path="/idea-evaluator" element={<IdeaEvaluatorPage />} />
                <Route path="/matches" element={<Protected><MatchesPage /></Protected>} />
                <Route path="/whatsapp" element={<WhatsAppPage />} />
                <Route path="/founder" element={<FounderPage />} />
                <Route path="/founders-story" element={<FounderPage />} />
                <Route path="/u/:id" element={<PublicUserPage />} />
                <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
                <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </AuthProvider>
      </CurrencyProvider>
    </I18nProvider>
  );
}

export default App;
